import { StockOrderListFilters } from "@/models/api/barcodeSystem/stockOrders/get";
import { StockOrderResource } from "@/models/api/barcodeSystem/stockOrders/get";
import { CompanyResource } from "../../../../models/api/barcodeSystem/barcodeCompanies/get";

export function defaultStockOrderFilters(): StockOrderListFilters {
  return {
    id:  null,
    crn:  null,
    statuses:  null,
    deliveryTypes:  null,
    facilityCodes:  null,
    shipDate :  null,
    billToCompanyIds:  null,
    companyIds:  null,
    isOpen: true,
    requiresReceiving:  null,
    receivedDate:  null,
    receivingProcessedDate :  null,
    anticipatedReceiveDate:  null,
    isLocked: null,
    shippingFacility: null
    } as StockOrderListFilters;
}

export function defaultStockOrder(): StockOrderResource {
  return {
    id: null,
    crn: null,
    shipDate: null,
    status: null,
    statusDescription: null,
    facilityCode: null,
    billToCompanyId: null,
    requiresReceiving: null,
    anticipatedReceiveDate: null,
    receivedDate: null,
    receivingProcessedDate :null,
    shippingFacility: null,
    locked: null,
    company: null,
    isOpen: null,
    isLocked: null,
    } as StockOrderResource;
}


